export default __webpack_public_path__ + "static/8-153f7402d2759728fd6f4ab22a220dcf.jpg";